import { Typography } from 'antd';

import { FormThemeOverrideContextProvider } from '../../../../components/forms/formTheme';
import AdminConsoleSection, {
  AdminConsoleSectionContent,
  AdminConsoleSectionTitleHeader,
} from '../../components/AdminConsoleSection';
import AdminConsoleContent from '../../layout/AdminConsoleContent';
import { formatAccountLabel } from '../../utils/adminFormatting';
import { AccountBusinessTypeField } from './AdminAccountDetailCommon';
import { FormTheme } from '../../../../styles/formThemeConstants';
import {
  AccountAddressBookSettingsSection,
  AccountCompanyInformationSection,
  AccountKeyContactsSection,
  AccountSetupSection,
} from './accountProfileSections';

export default function AdminAccountDetailProfile({
  account,
  viewMode,
  visible,
  bussinessTypes,
}) {
  return (
    <AdminConsoleContent
      titleIcon="file-invoice"
      titleId="admin.accountManagement.accountDetail.accountProfile"
      entityLabel={formatAccountLabel(account)}
      isEditing={!viewMode}
      visible={visible}
      headerRight={<AccountBusinessTypeField />}
    >
      <FormThemeOverrideContextProvider themeClassName={FormTheme.DarkOrange}>
        <AdminConsoleSection>
          <AdminConsoleSectionTitleHeader>
            <Typography.Title level={3}>
              {formatAccountLabel(account, { long: true })}
            </Typography.Title>
          </AdminConsoleSectionTitleHeader>
          <AdminConsoleSectionContent>
            <div className="spaces-vert-norm2 no-margin-form-items">
              <AccountSetupSection
                viewMode={viewMode}
                account={account}
                bussinessTypes={bussinessTypes}
              />
              <AccountCompanyInformationSection
                viewMode={viewMode}
                account={account}
              />
              <AccountAddressBookSettingsSection
                viewMode={viewMode}
                account={account}
              />
              <AccountKeyContactsSection
                viewMode={viewMode}
                account={account}
              />
            </div>
          </AdminConsoleSectionContent>
        </AdminConsoleSection>
      </FormThemeOverrideContextProvider>
    </AdminConsoleContent>
  );
}
